import { render, staticRenderFns } from "./FormaRecebimento.vue?vue&type=template&id=63f9dae0&scoped=true"
import script from "./FormaRecebimento.vue?vue&type=script&lang=js"
export * from "./FormaRecebimento.vue?vue&type=script&lang=js"
import style0 from "./FormaRecebimento.vue?vue&type=style&index=0&id=63f9dae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9dae0",
  null
  
)

export default component.exports